import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Card, CardContent, CardActions, Button, Typography, TextField, Box} from 'views/components';
import {CheckCircleOutline} from 'views/icons';
import {Translate} from 'views/module';

import backend from 'utils/backend';

const QuestionCard = (props) => {
  const {clientRn, user, statusProgressWrap: progressWrap, articleTitle, articleRN} = props;

  const [questionInput, setQuestionInput] = React.useState('');
  const [questionInputError, setQuestionInputError] = React.useState(false);
  const [questionSubmitted, setQuestionSubmitted] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const hasQuestionInput = Boolean(questionInput.trim());

  const handleQuestionInputChange = (event) => {
    setQuestionInput(event);
    if (questionInputError) {
      setQuestionInputError(false);
    }
  };

  const handleQuestionSubmit = () => {
    if (!questionInput.trim()) {
      setQuestionInputError(true);
      return;
    }

    if (questionSubmitted) {
      return;
    }

    progressWrap(async () => {
      setIsSubmitting(true);
      const body = {
        clientRelationshipRn: user.userRn,
        articleTitle,
        feedback: {
          comment: questionInput,
        },
      };

      await backend.clientSupport.createArticleFeedback(clientRn, articleRN, body);
      setQuestionSubmitted(true);
      setIsSubmitting(false);
    });
  };

  return (
    <Card>
      {
        !questionSubmitted &&
        <>
          <CardContent>
            <Typography sx={{fontWeight: 500, fontSize: '16px', color: '#2D2925', lineHeight: '150%'}}>
              <Translate expression={'questioncard.question'}/>
            </Typography>
            <TextField
              sx={{
                '& .MuiOutlinedInput-root': {
                  'borderRadius': '20px',
                  'alignItems': 'flex-start',
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: !questionInputError ? 'grey.400' : 'error.main',
                  },
                },
                'width': '100%',
                'mt': '8px',
              }}
              onChange={handleQuestionInputChange}
              minRows={7}
              maxRows={10}
              multiline
              value={questionInput}
            />
          </CardContent>
          <CardActions
            sx={{
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant='contained'
              onClick={handleQuestionSubmit}
              loading={isSubmitting}
              disabled={isSubmitting || !hasQuestionInput}
              disableElevation
            >
              <Translate expression={'questioncard.submit'}/>
            </Button>
          </CardActions>
        </>
      }
      {
        questionSubmitted &&
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 10,
            }}
          >
            <Box sx={{mr: 1}}>
              <CheckCircleOutline color='success' />
            </Box>
            <Box>
              <Typography variant='subtitle'>
                <Translate expression={'questioncard.submissionConfirmationMessage.Title'}/>
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                <Translate expression={'questioncard.submissionConfirmationMessage.Subtitle'}/>
              </Typography>
            </Box>
          </Box>
        </CardContent>
      }
    </Card>
  );
};

QuestionCard.propTypes = {
  clientRn: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
  articleTitle: PropTypes.string.isRequired,
  articleRN: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(QuestionCard));
